import { GetServerSidePropsContext } from 'next'
import { getTrackingCookies } from '../cookies'
import setCookie from './setCookie'
import { randomUUID } from 'crypto'

export default function usingTrackingData(context: GetServerSidePropsContext): {
  trackingConsented?: boolean
  ajsAnonymousId: string
  ajsUserId?: string
  sessionId?: string
} {
  // Use optimized batch cookie extraction - single iteration for multiple cookies
  const cookieString = context.req?.headers.cookie || ''
  const {
    trackingConsented,
    sessionId,
    ajsUserId: rawAjsUserId,
    ajsAnonymousId: rawAjsAnonymousId
  } = getTrackingCookies(cookieString)

  const ajsUserId = rawAjsUserId
    ? rawAjsUserId.replace(/[^a-z0-9-_]/gi, '')
    : undefined

  const ajsAnonymousId = rawAjsAnonymousId || randomUUID()

  if (!rawAjsAnonymousId) {
    setCookie(context.res, 'ajs_anonymous_id', ajsAnonymousId)
  }

  return { trackingConsented, sessionId, ajsAnonymousId, ajsUserId }
}
